<template id="ExpandIcon">
  <div v-if="expanded">
    <div>
      <span v-b-tooltip.hover title="Retract" class="fa fa-chevron-up" />
    </div>
  </div>
  <div v-else>
    <div>
      <span v-b-tooltip.hover title="Expand" class="fa fa-chevron-down" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandIcon",
  props: {
    expanded: Boolean,
  },
};
</script>
